import classNames from 'classnames';
import {useCallback} from 'react';

interface QuantityAdjusterProps {
  quantity: number;
  min?: number;
  onChange: (value: number) => void;
  containerClassName?: string;
}

export default function QuantityAdjuster({
  onChange,
  quantity,
  min = 1,
  containerClassName = 'quantity-container-product',
}: QuantityAdjusterProps) {
  const handleChange = useCallback(
    (quantity) => {
      if (typeof min === 'undefined' || min <= quantity) {
        onChange(quantity);
      }
    },
    [onChange, min],
  );
  return (
    <div
      className={classNames(
        'quantity-container js-quantity-container',
        containerClassName,
      )}
    >
      <button
        className="quantity-decrease js-decrease"
        disabled={typeof min !== 'undefined' && min >= quantity}
        type="button"
        title="Decrease Quantity"
        onClick={() => handleChange(quantity - 1)}
      >
        <span className="minus" />
      </button>
      <span className="quantity-amount js-quantity-amount">{quantity}</span>
      <button
        className="quantity-increase js-increase"
        type="button"
        title="Increase Quantity"
      >
        <span
          role="button"
          tabIndex={-1}
          className="plus"
          onClick={() => onChange(quantity + 1)}
        />
      </button>
    </div>
  );
}
